var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMailNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mail_new_svg__a)",
    d: "M21.928 6.365a2.476 2.476 0 00-.779-1.485 2.26 2.26 0 00-1.513-.594H5.363a2.26 2.26 0 00-1.513.594 2.48 2.48 0 00-.779 1.485l9.429 6.406 9.428-6.406z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mail_new_svg__b)",
    d: "M12.841 14.002a.641.641 0 01-.682 0L3.07 8.287v9.06c.001.598.245 1.17.68 1.593.435.423 1.024.66 1.64.661h14.22c.614 0 1.204-.238 1.639-.66.434-.424.679-.997.68-1.594v-9.06l-9.088 5.716z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mail_new_svg__a",
    x1: 5.9,
    x2: 12.049,
    y1: 11.445,
    y2: -0.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F75C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D22B24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mail_new_svg__b",
    x1: 5.9,
    x2: 15.269,
    y1: 17.832,
    y2: 4.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F75C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D22B24"
  })))));
}

export default __webpack_public_path__ + "./fonts/mail_new.828a65213f3a02d836cb4f10564408b1.svg";
export { SvgMailNew as ReactComponent };